import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={8}
    fill="none"
    viewBox="0 0 8 8"
    {...props}
  >
    <path
      fill="#5E3213"
      d="M4 5.063 1.564 7.479a.724.724 0 0 1-.522.23.718.718 0 0 1-.521-.23.718.718 0 0 1-.23-.52c0-.195.077-.37.23-.523L2.937 4 .521 1.585a.724.724 0 0 1-.23-.522c0-.195.077-.369.23-.521a.718.718 0 0 1 .52-.23c.195 0 .37.077.523.23L4 2.958 6.415.542a.724.724 0 0 1 .522-.23c.195 0 .369.077.521.23.153.152.23.326.23.52a.724.724 0 0 1-.23.523L5.042 4l2.416 2.436c.153.154.23.328.23.522a.718.718 0 0 1-.23.521.718.718 0 0 1-.52.23.724.724 0 0 1-.523-.23z"
    />
  </svg>
);
export default SvgCloseSmall;
